const FOCUSED_SELECT_OPTION_CLASSNAME = "focused";

export { FOCUSED_SELECT_OPTION_CLASSNAME };
//# sourceMappingURL=styles.mjs.map
